/**
 * @desc 删除季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/web/plan/quarter/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/mock/web/plan/quarter/delete',

    params,
  });
}
